import { isIso3166Alpha2 } from "@payair/e-com-common-sdk/core/Validators";
import { isBoolean, MUST_BE_BOOLEAN, validateArray, validateParam } from "../core/Helpers";
var validateAllowedCountryCode = function (allowedCountryCode) {
    if (!isIso3166Alpha2(allowedCountryCode)) {
        return "allowedCountryCode must be ISO 3166-1 alpha-2";
    }
    return null;
};
export var validateGooglePayShippingAddressParameters = function (googlePayShippingAddressParameters) {
    var errorMessage = [];
    // allowedCountryCodes: string[]
    var validationResult = validateArray(googlePayShippingAddressParameters.allowedCountryCodes, validateAllowedCountryCode);
    var allowedCountryCodes = validateParam(googlePayShippingAddressParameters.allowedCountryCodes, "allowedCountryCodes", validationResult === null, true, " ".concat(validationResult ? validationResult : ""));
    allowedCountryCodes && errorMessage.push(allowedCountryCodes);
    // phoneNumberRequired?: boolean
    var billingAddressRequired = validateParam(googlePayShippingAddressParameters.phoneNumberRequired, "phoneNumberRequired", isBoolean(googlePayShippingAddressParameters.phoneNumberRequired), false, MUST_BE_BOOLEAN);
    billingAddressRequired && errorMessage.push(billingAddressRequired);
    return errorMessage.length === 0 ? null : errorMessage.join(", ");
};
